import { useEffect, useState } from 'react';
import {
  useApi,
  configApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';

export function useAdminUser(): { isAdmin: boolean; loading: boolean } {
  const configApi = useApi(configApiRef);
  const identityApi = useApi(identityApiRef);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    identityApi
      .getProfileInfo()
      .then(profile => {
        if (cancelled) return;

        const adminEmailsRaw =
          configApi.getOptionalString('app.adminEmails') ?? '';
        const adminEmails = adminEmailsRaw
          .split(',')
          .map(e => e.trim().toLowerCase())
          .filter(Boolean);

        const userEmail = (profile.email ?? '').toLowerCase();
        setIsAdmin(adminEmails.includes(userEmail));
        setLoading(false);
      })
      .catch(() => {
        if (cancelled) return;
        setIsAdmin(false);
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [configApi, identityApi]);

  return { isAdmin, loading };
}
